import React, {Component} from 'react';
import {connect} from 'react-redux';
import get from 'get-value';
import Loader from '../../Loader';
import {Redirect, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    fetchTechDocInternalTicket,
    resetTechDocInternalTicket,
    updateTechDocInternalTicket
} from '../../../actions/techDoc/actionTechDocInternalTicket';
import {transformUpdateTechDocInternalTicketForSave} from '../Utils';
import {
    lockTechDocInternalTicket,
    resetRedirectAfterTechDocInternalLockTicket,
    unlockTechDocInternalTicket
} from '../../../actions/techDoc/actionTechDocInternalLockTicket';
import UploadingTechDocInternalTicketAttachments from './UploadingTechDocInternalTicketAttachments';
import checkRoles from '../../common/roleChecker/RoleChecker';
import EditLoadInternalTicketDataPage from './EditLoadInternalTicketDataPage';
import {
    DOCUMENTATION_INTERNAL_TICKET_STATUS_ANSWERED,
    DOCUMENTATION_INTERNAL_TICKET_STATUS_IN_PROGRESS,
    DOCUMENTATION_INTERNAL_TICKET_STATUS_NEW,
    DOCUMENTATION_INTERNAL_TICKET_STATUS_REOPENED,
    DOCUMENTATION_INTERNAL_TICKET_STATUS_TRANSFERRED,
    FORM_BUTTON_ANSWER,
    FORM_BUTTON_ESCALATE,
    FORM_BUTTON_TRANSFER_TO_REQUESTOR,
    OVAL_PLATE_ORDER_FORM
} from '../../../constants/formConstants';
import {moduleRoles} from '../../../utils/roles';
import alertMessages from '../../../intl/common/alertMessages';
import {injectIntl} from 'react-intl';
import {change} from 'redux-form';

class EditTechDocInternalTicketPage extends Component {
    constructor(props) {
        super(props);
        this.state = {ticketSubmittedAndShouldRedirect: false, createInternalTicket: false, skippedStatus: false, fetchedNewTicketData: false};
    }

    componentWillUnmount() {
        const {uuid, redirect} = this.props.lockTicket;
        if (!redirect) {
            this.props.unlockTechDocInternalTicket(uuid);
        }
        this.props.resetRedirectAfterTechDocInternalLockTicket();
    }

    componentDidMount() {
        this.props.resetTechDocInternalTicket();
        this.props.lockTechDocInternalTicket(this.props.match.params.ticketUuid);

        if (!this.props.location.redirectedAfterUpdate) {
            this.setState({fetchedNewTicketData: true});
            this.props.fetchTechDocInternalTicket(this.props.match.params.ticketUuid);
        }
        if (!!this.props.location.checkStatusSkipAfterUpdateRedirect) {
            this.setState({fetchedNewTicketData: true});
        }
    }

    missingEditorsNotes = (submitBy, dataForSend) => {
        if (submitBy === FORM_BUTTON_ANSWER || submitBy === FORM_BUTTON_ESCALATE || submitBy === FORM_BUTTON_TRANSFER_TO_REQUESTOR) {
            return !dataForSend.message;
        }
    }

    answeredToSuspiciousGroup = (submitBy, dataForSend) => {
        if (submitBy === FORM_BUTTON_ANSWER) {
            const assignedSolutionGroup = get(dataForSend, 'ticket.assignedSolutionGroup.id');
            return !this.props.previousSolutionGroups.includes(assignedSolutionGroup)
        }
    }

    handleSubmit = (values) => {
        const {submitBy} = values;
        const dataForSend = transformUpdateTechDocInternalTicketForSave(values);

        // Reset isTransferingToL3 flag after submission
        if (submitBy === FORM_BUTTON_ESCALATE) {
            this.props.change('isTransferingToL3', undefined);
        }
        if (submitBy === FORM_BUTTON_ANSWER) {
            this.props.change('isTransferingToL3', undefined);
        }

        if (this.answeredToSuspiciousGroup(submitBy, dataForSend)) {
            const groupName = get(dataForSend, 'ticket.assignedSolutionGroup.name');

            if (!window.confirm(this.props.intl.formatMessage(alertMessages.ESCALATION_SUSPICIOUS_GROUP_WARN, {groupName}))) {
                return;
            }
        }
        if (this.missingEditorsNotes(submitBy, dataForSend)) {
            if (!window.confirm(this.props.intl.formatMessage(alertMessages.ESCALATION_MISSING_EDITORS_NOTES_GROUP_WARN))) {
                return;
            }
        }
        this.props.updateTechDocInternalTicket(dataForSend);
        this.setState({ticketSubmittedAndShouldRedirect: true});
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.ticketSubmittedAndShouldRedirect && !this.state.ticketSubmittedAndShouldRedirect
            && prevProps.ticketData.isTicketCreating && !this.props.ticketData.isTicketCreating
            && this.props.ticketData.isTicketLoading) {
            this.props.lockTechDocInternalTicket(this.props.match.params.ticketUuid);
        }
    }

    render() {
        const {
            ticketData,
            attachmentsData,
            lockTicket,
            loggedUser
        } = this.props;

        if (lockTicket.redirect) {
            return <Redirect to={`/documentation/internalTicket/view/${lockTicket.uuid}`}/>;
        }

        let formType = false;
        if (get(ticketData, 'ticket.docType', {default: false})) {
            formType = ticketData.ticket.docType;
        }

        if (Array.isArray(attachmentsData.attachmentsForUpload) && (attachmentsData.attachmentsForUpload.length > 0)) {
            return <UploadingTechDocInternalTicketAttachments attachments={attachmentsData.attachmentsForUpload}
                                                attachmentsUrl={ticketData.newAttachments}
                                                correlationId={ticketData.correlationId}
                                                isAttachmentUploading={attachmentsData.isTicketAttachmentUploading}
                                                formType={formType}/>
        }

        if (ticketData.isTicketLoading
            || ticketData.isTicketCreating
            || lockTicket.isTicketLocking
            || !formType
        ) {
            return <Loader/>;
        }

        if (this.state.ticketSubmittedAndShouldRedirect && !ticketData.isTicketCreating && !ticketData.isTicketLoading && get(ticketData, 'ticket.uuid', {default: false})) {
            return <Redirect to={{
                pathname: `/documentation/internalTicket/view/${ticketData.ticket.uuid}`,
                redirectedAfterUpdate: true
            }}/>;
        }

        if (get(ticketData, 'ticket.uuid', {default: false})
            && [DOCUMENTATION_INTERNAL_TICKET_STATUS_NEW, DOCUMENTATION_INTERNAL_TICKET_STATUS_ANSWERED, DOCUMENTATION_INTERNAL_TICKET_STATUS_TRANSFERRED, DOCUMENTATION_INTERNAL_TICKET_STATUS_REOPENED].includes(get(ticketData, 'ticket.status', {default: false}))
            && moduleRoles.isSGEditorDocumentationInSG(loggedUser, get(ticketData, 'ticket.assignedSolutionGroup.id', {default: ''}))
            && !this.state.skippedStatus
            && this.state.fetchedNewTicketData
        ) {
            this.setState({skippedStatus: true});
            this.props.updateTechDocInternalTicket({
                ticket: {
                    pfxNumber: ticketData.ticket.pfxNumber,
                    sfxNumber: ticketData.ticket.sfxNumber,
                    status: DOCUMENTATION_INTERNAL_TICKET_STATUS_IN_PROGRESS,
                    uuid: ticketData.ticket.uuid,
                }
            });
            return <Loader/>;
        }

        return (
            <EditLoadInternalTicketDataPage formType={formType} handleSubmit={this.handleSubmit}/>
        );
    }
}

const getPreviousSolutionGroups = (state) => {
    const logs = get(state, 'techDocInternalTicket.logs') || [];

    const fromIds = logs.map(item => item.solutionGroup && item.solutionGroup.id);
    const toIds = logs.map(item => item.toSolutionGroup && item.toSolutionGroup.id);

    return [...new Set([...fromIds, ...toIds])];
}

const mapStateToProps = (state) => ({
    loggedUser: state.profile.userDetail.roles,
    ticketData: state.techDocInternalTicket,
    lockTicket: state.techDocLockInternalTicketCheck,
    attachmentsData: state.techDocInternalTicketAttachment,
    previousSolutionGroups: getPreviousSolutionGroups(state)
});

const mapDispatchToProps = {
    fetchTechDocInternalTicket,
    resetTechDocInternalTicket,
    lockTechDocInternalTicket,
    unlockTechDocInternalTicket,
    resetRedirectAfterTechDocInternalLockTicket,
    updateTechDocInternalTicket,
    change,
};

EditTechDocInternalTicketPage.propTypes = {
    location: PropTypes.object,
    ticketData: PropTypes.object.isRequired,
    fetchTechDocInternalTicket: PropTypes.func.isRequired,
    resetTechDocInternalTicket: PropTypes.func.isRequired,
    lockTechDocInternalTicket: PropTypes.func.isRequired,
    unlockTechDocInternalTicket: PropTypes.func.isRequired,
    resetRedirectAfterTechDocInternalLockTicket: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    updateTechDocInternalTicket: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
};

export default checkRoles(withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(EditTechDocInternalTicketPage))), ['TD_SG_EDITOR']);

